import fetch from "../fetch";

export default ({ id }) =>
  fetch({
    path: `/hy/funds/${id}`,
    method: "DELETE",
  });
